import { base_url } from "./Network";

export const saveLocalData = (type, value) => {
  localStorage.setItem(type, JSON.stringify(value));
};

export const getSavedData = (type) => {
  if (localStorage.getItem(type))
    return JSON.parse(localStorage.getItem(type));
  return "";
};

export const appendImageUrl = (url = "") => {
  return base_url.slice(0, base_url.length - 1) + url;
};

export function isMobiledevice() {
  if (window.innerWidth < 770) return true;
  else return false;
}
